import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSketch24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconSketch24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="m12.043 4.002 4.942.575a.38.38 0 0 1 .262.156l3.678 5.111a.4.4 0 0 1-.015.486l-8.766 10.601a.185.185 0 0 1-.288 0L3.09 10.33a.4.4 0 0 1-.016-.486l3.678-5.111a.38.38 0 0 1 .262-.155l4.943-.576a.4.4 0 0 1 .085 0m1.026 1.103a.08.08 0 0 0-.108-.006.085.085 0 0 0-.019.106l.007.01 2.787 3.578a.2.2 0 0 1 .042.122.193.193 0 0 1-.174.195H8.412a.2.2 0 0 1-.12-.043.2.2 0 0 1-.038-.26l.01-.014 2.787-3.578a.085.085 0 0 0-.006-.11.08.08 0 0 0-.104-.008l-.01.008L7.156 9.02a.15.15 0 0 1-.115.046.154.154 0 0 1-.144-.148v-.015l.13-2.835a.08.08 0 0 0-.059-.08.075.075 0 0 0-.087.049l-.003.01-.716 3.263a.31.31 0 0 1-.211.231l-.02.006-1.772.393a.08.08 0 0 0-.06.076c0 .04.029.073.066.078h1.777a.3.3 0 0 1 .254.142l.01.018 4.24 7.797a.11.11 0 0 0 .147.048.12.12 0 0 0 .059-.144l-.005-.012-3.427-7.514a.24.24 0 0 1-.021-.1c0-.124.093-.225.21-.234h9.165q.05 0 .097.022a.237.237 0 0 1 .115.296l-.006.015-3.427 7.515a.12.12 0 0 0 .047.152c.051.03.115.014.148-.034l.007-.01 4.239-7.797a.3.3 0 0 1 .243-.159h1.788a.076.076 0 0 0 .074-.062.08.08 0 0 0-.048-.09l-.01-.003-1.772-.393a.31.31 0 0 1-.226-.216l-.005-.02-.716-3.264a.076.076 0 0 0-.077-.061.08.08 0 0 0-.072.071v.01l.13 2.836a.16.16 0 0 1-.045.118.15.15 0 0 1-.202.01l-.012-.01z"
            />
        </svg>
    );
}
export default memo(IconSketch24);
